import { useState } from "react"
import styled from "styled-components"

import { Button, Text } from "@minuthq/meatball-ui-react"

import { GuestConversationNavItem } from "src/components/GuestInbox/GuestConversations/GuestConversationNavItem"
import { useFetchHomeGuestsInfinite } from "src/data/guests/queries/guestQueries"
import { spacing } from "src/ui/spacing"

import { ParadiseHomeCreateSandboxGuestDialog } from "./ParadiseHomeCreateSandboxGuestDialog"

export function ParadiseHomeCompassSandboxGuestList({
  homeId,
  selectedGuestId,
  onSelectGuest,
}: {
  homeId: string
  selectedGuestId: string | null
  onSelectGuest: (guestId: string) => void
}) {
  const [showCreateSandboxGuestDialog, setShowCreateSandboxGuestDialog] =
    useState(false)

  const fetchHomeGuests = useFetchHomeGuestsInfinite({
    homeId,
    filters: {
      limit: 50,
      include_anonymized: false,
    },
  })

  const guests =
    fetchHomeGuests.data?.pages.flatMap((page) => page.guests) ?? []

  return (
    <Wrapper>
      <Header>
        <Text variant="heading3">Guests</Text>

        <Button
          variant="minimal"
          size="small"
          onClick={() => setShowCreateSandboxGuestDialog(true)}
        >
          Create test guest
        </Button>
      </Header>

      {guests.map((guest) => (
        <GuestConversationNavItem
          key={guest.guest_id}
          title={guest.name}
          summary={guest.guest_id}
          onClick={() => onSelectGuest(guest.guest_id)}
          active={selectedGuestId === guest.guest_id}
        />
      ))}

      {showCreateSandboxGuestDialog && (
        <ParadiseHomeCreateSandboxGuestDialog
          onClose={() => setShowCreateSandboxGuestDialog(false)}
          homeId={homeId}
          onGuestCreated={(guestId) => {
            onSelectGuest(guestId)
          }}
        />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  padding: ${spacing.L};
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacing.L};
`
